import useDomains from '@gr/portal/hooks/useDomains';
import { Autocomplete } from '@Wonder-Cave/ui';
import { IDropdownValue } from '../Dropdown';

interface IDomainsDropdownProps {
  value: string | IDropdownValue;
  onChange: (newValue: IDropdownValue | undefined) => void;
  onBlur: () => void;
  disabled?: boolean;
  errorMessage?: string | undefined;
  showError?: boolean;
}

const DomainsDropdown = ({
  value,
  onChange,
  onBlur,
  disabled,
  errorMessage,
  showError,
}: IDomainsDropdownProps): JSX.Element => {
  const { data: domainsData } = useDomains();

  const domains: IDropdownValue[] =
    domainsData?.map((domain) => ({
      label: domain.url ?? '',
      value: domain.url ?? '',
    })) ?? [];

  return (
    <Autocomplete
      label="Domain"
      value={domains.find((provider) => provider.value === value)}
      options={domains}
      onChange={onChange}
      onBlur={onBlur}
      showError={showError}
      error={errorMessage}
      disabled={disabled}
      search={false}
    />
  );
};

export default DomainsDropdown;
